import { render, staticRenderFns } from "./rest.vue?vue&type=template&id=48279640&scoped=true&"
import script from "./rest.vue?vue&type=script&lang=js&"
export * from "./rest.vue?vue&type=script&lang=js&"
import style0 from "./rest.vue?vue&type=style&index=0&id=48279640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48279640",
  null
  
)

export default component.exports